<div class="w-full overflow-x-hidden">
  <app-navigation></app-navigation>
  <app-hero-section></app-hero-section>
  <app-tools-section></app-tools-section>
  <app-learn-section></app-learn-section>
  <app-products-section></app-products-section>
  <app-faq-section></app-faq-section>
  <app-footer></app-footer>
</div>
